import Vue from 'vue';

class CrudService {
  constructor() {
    this.requestAccess = true;
  }

  post(link, params) {
    return this.sendRequest(`${Vue.prototype.$deviceConfig.API_URL}/api/${link}`, params, 'post')
  }

  get(link, params) {
    return this.sendRequest(`${Vue.prototype.$deviceConfig.API_URL}/api/${link}`, params, 'get')
  }

  put(link, params) {
    return this.sendRequest(`${Vue.prototype.$deviceConfig.API_URL}/api/${link}`, params, 'put')
  }

  clearUser() {
    Vue.prototype.$notificationService.error('d_ws_error_unauthorized');
    Vue.prototype.$authService.clearUser();
  }

  sendRequest(link, params, method) {
    const sendRequestAxios = () => {
      const headers = {
        token: localStorage.getItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.TOKEN),
        uid: localStorage.getItem(Vue.prototype.$deviceConfig.LOCALSTORAGE_CONSTANTS.DEVICE_TOKEN)
      };

      if (method === 'get') {
        return Vue.prototype.axios({
          method: method,
          url: link,
          headers,
          params: params ? params : null
        });
      } else if (method === 'post') {
        return Vue.axios.post(link, params, {
          headers
        });
      } else if (method === 'put') {
        return Vue.axios.put(link, params, {
          headers
        });
      }
    };

    return new Promise((resolve, reject) => {
      sendRequestAxios().then((response) => {
        resolve(response);
      })
        .catch((error) => {
          if (error && error.response && error.response.data && error.response.data.code && error.response.data.code === Vue.prototype.$ERROR_CODE.TOKEN_EXPIRED) {
            if (this.requestAccess) {
              this.requestAccess = false;

              Vue.prototype.$authService.refresh().then(({data}) => {
                Vue.prototype.$authService.login(data.access_token, data.refresh_token, data.user);

                this.requestAccess = true;
                Vue.prototype.$eventEmitter.emit('refreshToken', this.requestAccess);

                sendRequestAxios().then((finalResponse) => {
                  resolve(finalResponse)
                }).catch((err) => {
                  this.clearUser();
                  reject(err);
                })
              }).catch((err) => {
                this.clearUser();
                reject(err);
              })
            } else {
              Vue.prototype.$eventEmitter.subscribe('refreshToken', (data) => {
                if (data) {
                  sendRequestAxios().then((finalResponse) => {
                    resolve(finalResponse)
                  }).catch((err) => {
                    this.clearUser();
                    reject(err);
                  })
                }
              })
            }
          } else if (error && error.response && error.response.data && error.response.data.code && error.response.data.code === Vue.prototype.$ERROR_CODE.UNAUTHORIZED) {
            this.clearUser();
            reject(error);
          } else if (error && error.response && error.response.data && error.response.data.code && error.response.data.code === Vue.prototype.$ERROR_CODE.NOT_HAVE_PERMISSIONS) {
            this.clearUser();
            reject(error);
          } else {
            reject(error);
          }
        })
    })
  }

}

export default CrudService;
